import volunteeringData from '../data/volunteering.json';
import { Volunteering } from '../models/volunteering.interface';

export class VolunteeringService {
    private volunteering: Volunteering[] = [];

    constructor() {
        this.volunteering = volunteeringData.volunteering as Volunteering[];
    }

    getVolunteering(): Volunteering[] {
        return this.volunteering;
    }
}

export const volunteeringService = new VolunteeringService();
